<template>
  <div class="infoDetail">
    <div class="ms">
      当前位置：<span @click="toIndex">废旧物资价格行情</span
      ><i class="el-icon-arrow-right"></i>
      <span @click="toInformations">焦点资讯</span>
      <i class="el-icon-arrow-right"></i> 资讯详情
    </div>
    <div class="detail">
      <p class="title">{{ obj.title }}</p>
      <div class="content" v-html="obj.newsContent"></div>
    </div>
    <MyTips />
  </div>
</template>

<script>
import MyTips from '../MyTips.vue'
export default {
  name: 'infoDetail',
  components: {
    MyTips
  },
  data() {
    return {
      obj: {
        title: '',
        newsContent: ''
      }
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    toIndex() {
      this.$router.replace('/price/index')
    },
    toInformations() {
      this.$router.replace('/price/informationList')
    },
    async getDetail() {
      const res = await this.$api.price.getNews({ id: this.$route.query.id })
      if (res) {
        this.obj = res
      }
    }
  }
}
</script>

<style lang="less" scoped>
.infoDetail {
  min-height: calc(100vh - 310px);
  .ms {
    font-size: 14px;
    color: #999999;
    display: flex;
    align-items: center;
    background: #f7f7f7;
    padding-bottom: 15px;
    margin-top: 15px;
    i {
      margin: 0 5px;
    }
    span {
      cursor: pointer;
    }
  }
  .detail {
    padding: 0 10px;
    .title {
      text-align: center;
      font-weight: bold;
      font-size: 22px;
      margin: 20px 0;
    }
    .content {
      line-height: 25px;
      padding: 20px 0;
      text-indent: 30px;
      img {
        margin: 0 auto;
        display: block;
      }
    }
  }
}
</style>
